import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, Header as BaseHeader, Segment } from 'semantic-ui-react';

import styles from './styles';
import { LoginButton, LogoutButton } from '../Buttons';

class Header extends Component {
  renderContent() {
    switch (this.props.auth) {
      case null:
        return null;
      case false:
        return <LoginButton />;
      default:
        return <LogoutButton />;
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <Segment clearing basic vertical style={{ padding: '0' }}>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                {this.props.auth && this.props.children}
                <Link to={this.props.auth ? '/search' : '/'}>
                  <BaseHeader as="h1" style={{ textShadow: '0 1px 1px #555' }}>
                    gov<span style={{ color: '#dd4b39' }}>2</span>txt
                  </BaseHeader>
                </Link>
              </Grid.Column>
              <Grid.Column>{this.renderContent()}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

Header.propTypes = {
  auth: PropTypes.any,
  children: PropTypes.any,
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js